import { useCallback, useState } from "react";

/**
 * Builds a "Comments (N)" label from the count reported by
 * FeatureCommentsTabComponent. The count is tied to the feature it was
 * reported for so a stale count never shows against a different item.
 */
export const useCommentsCountLabel = (
  featureId: string | undefined,
  baseLabel = "Comments"
) => {
  const [reported, setReported] = useState<{
    featureId: string;
    count: number;
  } | null>(null);

  const onCommentsCountChange = useCallback(
    (count: number) => {
      if (featureId) setReported({ featureId, count });
    },
    [featureId]
  );

  const label =
    reported && reported.featureId === featureId
      ? `${baseLabel} (${reported.count})`
      : baseLabel;

  return { label, onCommentsCountChange };
};
